import { useState } from 'react';

import { FieldBlueprint, FieldTypes, NumberFieldBlueprint } from '@zinnia/form-engine-sdk';

import { FieldDataHookReturnValue, useCastBlueprintToFieldType } from '../../Helpers/helperTypes';

export type NumberFieldData = Pick<NumberFieldBlueprint, 'numericalDataType'>;

export type NumberFieldSetters = {
  setNumericalDataType: React.Dispatch<React.SetStateAction<NumberFieldData['numericalDataType']>>;
};

export function useNumberFieldData({
  initialData,
}: {
  initialData?: Partial<FieldBlueprint>;
}): FieldDataHookReturnValue<NumberFieldData, NumberFieldSetters> {
  const initialDataAsNumberField = useCastBlueprintToFieldType<NumberFieldBlueprint>(FieldTypes.number, initialData);

  const [numericalDataType, setNumericalDataType] = useState<NumberFieldData['numericalDataType']>(
    initialDataAsNumberField?.numericalDataType,
  );

  return {
    data: {
      numericalDataType,
    },
    setters: {
      setNumericalDataType,
    },
    clearData: () => {
      setNumericalDataType(initialDataAsNumberField?.numericalDataType);
    },
  };
}
